import { DETECTION_ALGORITHM_LIST, DETECTION_ALGORITHM_LIST_ERROR, DETECTION_ALGORITHM_LIST_SUCCESS, EDIT_FILTER_CONFIG, EDIT_FILTER_CONFIG_ERROR, EDIT_FILTER_CONFIG_SUCCESS, DETECTION_ALGORITHM_INFO_CREATE, DETECTION_ALGORITHM_INFO_CREATE_ERROR, DETECTION_ALGORITHM_INFO_CREATE_SUCCESS, DETECTION_ALGORITHM_INFO_DELETE, DETECTION_ALGORITHM_INFO_DELETE_ERROR, DETECTION_ALGORITHM_INFO_DELETE_SUCCESS, DETECTION_ALGORITHM_INFO_UPDATE, DETECTION_ALGORITHM_INFO_UPDATE_DATA, DETECTION_ALGORITHM_INFO_UPDATE_ERROR, DETECTION_ALGORITHM_INFO_UPDATE_SUCCESS } from './constants';

export default function detectionAlgorithmInfoReducer(state, action) {
	switch (action.type) {
	case DETECTION_ALGORITHM_INFO_UPDATE_DATA :
		return { ...state, detectionalgorithmUpdateData : action.payload };
	case DETECTION_ALGORITHM_INFO_UPDATE :
		return { ...state, loading : true, error : false};
	case DETECTION_ALGORITHM_INFO_UPDATE_SUCCESS :
		return { ...state, loading : false, error : false};
	case DETECTION_ALGORITHM_INFO_UPDATE_ERROR : 
		return { ...state, loading : false, error : true};
	case DETECTION_ALGORITHM_INFO_CREATE:
		return { ...state, loading : true, error : false };
	case DETECTION_ALGORITHM_INFO_CREATE_SUCCESS :
		return { ...state, loading : false, error : false};
	case DETECTION_ALGORITHM_INFO_CREATE_ERROR :
		return { ...state, loading : false, error : true };
	case DETECTION_ALGORITHM_INFO_DELETE :
		return { ...state, loading : true, error : false};
	case DETECTION_ALGORITHM_INFO_DELETE_SUCCESS :
		return { ...state, loading : false, error : false };
	case DETECTION_ALGORITHM_INFO_DELETE_ERROR :
		return { ...state, loading : false, error : true };

	case EDIT_FILTER_CONFIG :
		return {...state, loading : true , error : false};
	case EDIT_FILTER_CONFIG_SUCCESS :
		return {...state, loading : false , error : false};
	case EDIT_FILTER_CONFIG_ERROR :
		return {...state, loading : false , error : true};

	case DETECTION_ALGORITHM_LIST:
		return {...state, loading : false , error : false};
	case DETECTION_ALGORITHM_LIST_SUCCESS:
		// if (action.payload && action.payload && action.payload.length > 0) {
		//  action.payload.map( (item) => {
		//      let data = {};                        
		//      data.id = item.id ? item.id : 0;
		//      data.name = item.name;
		//      data.configs = item && item?.configs;
		//      return detectionalgorithm.push(data);
		//  });
		// }
		return { ...state, detectionalgorithm:action.payload ,  loading: false, error: false };
	case DETECTION_ALGORITHM_LIST_ERROR:
		return {...state, loading : false , error : true};
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}